export function getNextCommunityOffset(
  offset: number,
  received: number,
  total: number,
): number | undefined {
  // Counts can outlive products/shops; an empty page must never request itself.
  const nextOffset = offset + received;
  return received > 0 && nextOffset < total ? nextOffset : undefined;
}
